export class ContactPerson {
    id: number;

	name: string;
	email: string;
	preferential: boolean = false;
	username: string;
	
	clientId: number;
}